import { TRADE_CATEGORIES, tradeModels } from "@/lib/tradeCatalog";
import { ModelPicker } from "../ModelPicker";
import { Question, Choices, tradeInput } from "./TradeParts";

// Perguntas 1 e 2: aparelho (categoria, modelo, GB) e cor. sfx diferencia os testids do 2º aparelho em diante.
export const TradeDevice = ({ f, setF, sfx = "" }) => {
  const models = tradeModels(f.category);
  const entry = models.find((m) => m.name === f.model);
  const pickModel = (name) => {
    const m = models.find((x) => x.name === name);
    setF((s) => ({ ...s, model: name, storage: m?.storages?.includes(s.storage) ? s.storage : m?.storages?.[0] || "", color: m?.colors?.includes(s.color) ? s.color : "" }));
  };
  return (
    <>
      <Question n={1} label="Modelo e armazenamento (GB)" testid={`trade-q-model${sfx}`}>
        <Choices testid={`trade-category${sfx}`} value={f.category} options={TRADE_CATEGORIES.map((c) => [c.id, c.label])}
          onChange={(category) => setF((s) => (s.category === category ? s : { ...s, category, model: "", storage: "", color: "" }))} />
        <ModelPicker testid={`trade-model${sfx}`} value={f.model} onChange={pickModel} options={models.map((m) => m.name)} selectOnly
          groupOf={(o) => models.find((m) => m.name === o)?.group} placeholder="Toque para escolher o modelo" className={`${tradeInput} mt-3`} />
        {entry?.storages?.length > 0 && (
          <div className="mt-3">
            <Choices testid={`trade-storage${sfx}`} value={f.storage} options={entry.storages.map((s) => [s, s])} onChange={(storage) => setF((s) => ({ ...s, storage }))} />
          </div>
        )}
      </Question>
      <Question n={2} label="Cor" testid={`trade-q-color${sfx}`}>
        {entry?.colors?.length ? (
          <Choices testid={`trade-color${sfx}`} value={f.color} options={entry.colors.map((c) => [c, c])} onChange={(color) => setF((s) => ({ ...s, color }))} />
        ) : (
          <input data-testid={`trade-color-input${sfx}`} value={f.color} maxLength={40} onChange={(e) => setF((s) => ({ ...s, color: e.target.value }))} placeholder="Escolha o modelo primeiro" className={tradeInput} />
        )}
      </Question>
    </>
  );
};
